import React from 'react';
import { Link } from 'react-router-dom';
import { useAccount } from '../account/AccountContext.jsx';

// One line under a game: sign in to keep progress on every device, or (signed
// in) that it's being saved to the account. Renders the signed-out text in the
// prerendered HTML and on first render, so hydration matches.
function ProgressNote({ returnTo }) {
  const { user, progress } = useAccount();
  if (user) {
    const text = progress.status === 'error'
      ? "Couldn't sync just now. Your progress is safe in this browser and we'll try again."
      : 'Your progress is saved to your Spark & Spiral account.';
    return (
      <p className="progress-note is-signed-in">
        {text} <Link to="/account">Your progress</Link>
      </p>
    );
  }
  const href = returnTo ? `/account?return=${encodeURIComponent(returnTo)}` : '/account';
  return (
    <p className="progress-note">
      Playing on more than one device? <Link to={href}>Create a free account</Link> to save your progress and pick up where you left off.
    </p>
  );
}

export default ProgressNote;
